import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SearchIcon from '@material-ui/icons/Search';

import { fade } from '@material-ui/core/styles/colorManipulator';
import moment from 'moment'

import api from "../../../api/backend"

import Editor from './Editor'

const styles = theme => ({
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class department extends React.Component {
    state = {
        open: false, title: '', description: '', departments: [], tmpDepartments: []
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    getDepartments = () => {
        api.getDepartments(true).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ departments: json, tmpDepartments: json })
            }
        }).catch(() => { })
    }

    find = () => {
        const { tmpDepartments, term } = this.state
        if (term.length > 0) {
            this.setState({ departments: tmpDepartments.filter((e) => { return e.title.includes(term) || e.description.includes(term) }) })
        } else {
            this.setState({ departments: tmpDepartments })
        }
    }

    createDepartment = () => {
        const { title, description } = this.state;
        console.log(title, description);
        api.createDepartment({ title, description }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.getDepartments();
                this.setState({ open: false, title: '', description: '' })
            } else {
                console.error('ไม่สามารถสร้างผู้ใช้ใหม่ได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    };

    componentDidMount() {
        this.getDepartments();
    }

    validate = () => {
        const { title, description } = this.state;
        if (title && title.length > 0 && description && description.length > 0) {
            return true
        } else {
            return false
        }
    }

    render() {
        const { classes } = this.props;
        const { title, description, departments } = this.state;
        return (
            <div>
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            กลุ่มวิชา
            </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={(event) => { this.setState({ term: event.target.value }) }}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.find()
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>

                    <Grid container justify="center">
                        <Grid item xs={4}>
                            <Button variant="contained" color="primary" fullWidth onClick={this.handleClickOpen}>
                                สร้างใหม่
                            </Button>
                        </Grid>
                    </Grid>
                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">กลุ่มวิชา</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                สร้าง และแก้ไขกลุ่มวิชา
                        </DialogContentText>
                            <Grid container spacing={24} style={{ paddingTop: 30 }}>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="title"
                                        name="title"
                                        label="ชื่อกลุ่มวิชา"
                                        fullWidth
                                        value={title}
                                        onChange={(event) => { this.setState({ title: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="description"
                                        name="description"
                                        label="รายละเอียด"
                                        fullWidth
                                        multiline
                                        rows={6}
                                        value={description}
                                        onChange={(event) => { this.setState({ description: event.target.value }) }}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                ปิด
                        </Button>
                            <Button onClick={this.createDepartment} color="primary" disabled={!this.validate()}>
                                สร้าง
                        </Button>
                        </DialogActions>
                    </Dialog>
                    <br /> <br />
                    <Paper>
                        <Table padding="dense">
                            <TableHead>
                                <TableRow>
                                    <TableCell>ชื่อกลุ่มวิชา</TableCell>
                                    <TableCell align="right" style={{ width: 150 }}>แก้ไขล่าสุด</TableCell>
                                    <TableCell align="right" style={{ width: 150 }}>สถานะ</TableCell>
                                    <TableCell align="right" style={{ width: 200 }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {departments.map(department => (
                                    <TableRow key={department.id}>
                                        <TableCell component="th" scope="row">
                                            {department.title}
                                        </TableCell>
                                        <TableCell align="right">{moment(department.modified).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="right">{department.deactivated ? 'ไม่ใช้งาน' : ' ใช้งาน'}</TableCell>
                                        <TableCell align="right">
                                            <Editor department={department} onUpdateCompleted={this.getDepartments} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
            </div>
        );
    }
}

department.propTypes = {
};

export default withStyles(styles)(department);